document.addEventListener("DOMContentLoaded", function () {
  const fullTextElements = document.querySelectorAll(".full-text");

  fullTextElements.forEach(function (fullText) {
    // Define the maximum height in pixels
    const maxHeight = 200; // Example: 200px

    // Initially set the element to the maximum height to measure its full height
    fullText.style.maxHeight = "none";

    // Check if the element's height exceeds the maximum height
    if (fullText.offsetHeight > maxHeight) {
      // Apply the maximum height and overflow hidden to truncate the content
      fullText.style.maxHeight = maxHeight + "px";
      fullText.style.overflow = "hidden";
      fullText.nextElementSibling.style.display = "block"; // Make the "Read More" link visible
    } else {
      fullText.nextElementSibling.style.display = "none"; // Hide the "Read More" link if content is within the limit
    }
  });

  const readMoreLinks = document.querySelectorAll(".read-more");

  readMoreLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const content = this.previousElementSibling;

      if (!content.classList.contains("expanded")) {
        content.classList.add("expanded");
        content.style.maxHeight = "none"; // Expand to show all content
        link.textContent = "Read Less";
      } else {
        content.classList.remove("expanded");
        content.style.maxHeight = "100px"; // Collapse to show partial content
        link.textContent = "Read More";
      }
    });
  });
});
